import { useEffect, useState, type FormEvent } from 'react';
import { Modal } from '../../../app/components/foundation';
import type { UpdateUserPayload } from '../api/users.api';
import type { User } from '../types/user.types';

export interface UserEditTenantOption {
  id: number;
  name: string;
}

interface UserEditDialogProps {
  open: boolean;
  user: User;
  tenants: UserEditTenantOption[];
  submitting: boolean;
  error: string | null;
  onClose: () => void;
  onSubmit: (payload: UpdateUserPayload) => Promise<void>;
}

export function UserEditDialog({
  open,
  user,
  tenants,
  submitting,
  error,
  onClose,
  onSubmit,
}: UserEditDialogProps) {
  const [fullName, setFullName] = useState('');
  const [username, setUsername] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [tenantId, setTenantId] = useState('');
  const [validationError, setValidationError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setFullName(user.name === String(user.telegramId) ? '' : user.name);
    setUsername(user.username === '-' ? '' : user.username);
    setPhoneNumber(user.phone === '-' ? '' : user.phone);
    setTenantId(user.tenant?.tenantId ?? '');
    setValidationError(null);
  }, [open, user]);

  if (!open) return null;

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const parsedTenantId = Number(tenantId);
    if (!Number.isInteger(parsedTenantId) || parsedTenantId <= 0) {
      setValidationError('انتخاب تننت الزامی است.');
      return;
    }
    setValidationError(null);
    await onSubmit({
      full_name: fullName.trim() || null,
      username: username.trim() || null,
      phone_number: phoneNumber.trim() || null,
      tenant_id: parsedTenantId,
    });
  }

  return (
    <Modal open={open} onClose={onClose} title="ویرایش کاربر" className="vania-user-edit-modal">
      <form className="vania-user-edit-form" onSubmit={handleSubmit}>
        <label>نام<input value={fullName} onChange={(event) => setFullName(event.target.value)} disabled={submitting} /></label>
        <label>نام کاربری تلگرام<input dir="ltr" value={username} onChange={(event) => setUsername(event.target.value)} disabled={submitting} /></label>
        <label>موبایل<input dir="ltr" value={phoneNumber} onChange={(event) => setPhoneNumber(event.target.value)} disabled={submitting} /></label>
        <label>تننت<select value={tenantId} onChange={(event) => setTenantId(event.target.value)} disabled={submitting || tenants.length === 0} required><option value="">انتخاب کنید</option>{tenants.map((tenant) => <option key={tenant.id} value={tenant.id}>{tenant.name}</option>)}</select></label>
        {(validationError || error) ? <p className="vania-user-action-error" role="alert">{validationError || error}</p> : null}
        <div className="vania-user-action-row">
          <button type="button" onClick={onClose} disabled={submitting}>انصراف</button>
          <button type="submit" disabled={submitting || tenants.length === 0}>{submitting ? 'در حال ذخیره…' : 'ذخیره تغییرات'}</button>
        </div>
      </form>
    </Modal>
  );
}
